const horizontalAlignments = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

const verticalAlignments = {
  top: 'flex-start',
  middle: 'center',
  bottom: 'flex-end',
};

export const getAlignmentHorizontal = (alignment) => {
  if (!alignment) return 'center';
  const [position] = alignment.split('-');
  return horizontalAlignments[position] || 'center';
};

export const getAlignmentVertical = (alignment) => {
  if (!alignment) return 'center';
  const [, direction] = alignment.split('-');
  return verticalAlignments[direction] || 'center';
};
